import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconProjectsAddPlus = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("line", {
		x1: 30.5,
		y1: 17.5,
		x2: 6.5,
		y2: 17.5,
		stroke: "currentColor",
		strokeWidth: 3,
		strokeLinecap: "round"
	}), /* @__PURE__ */ _jsx("line", {
		x1: 18.5,
		y1: 5.5,
		x2: 18.5,
		y2: 29.5,
		stroke: "currentColor",
		strokeWidth: 3,
		strokeLinecap: "round"
	})]
});
export default SvgIconProjectsAddPlus;
